{
  "breaches": {
    "count": "Vi har inte hittat några dataläckor för ditt konto. | Dina kontouppgifter har läckt ut i en dataläcka. | Dina kontouppgifter har läckt ut i {count} dataläckor.",
    "discovered": "Den här läckan upptäcktes först den {date}.",
    "empty": {
      "text": "Vi har inte hittat några dataläckor för ditt konto.",
      "title": "Inga dataläckor hittades"
    },
    "high": "Hög",
    "medium": "Medium",
    "title": "Dataläckor",
    "watchlist": {
      "button": "Lägg till e-post",
      "text": "Övervakade e-postadresser",
      "title": "Övervakningslista"
    }
  },
  "cards": {
    "breaches": {
      "text": "På den här sidan kan du se om data från ditt e-postkonto har exponerats i en extern dataläcka. Vi kategoriserar dataläckorna efter deras allvarlighetsgrad och den typ av data som har läckt. Kom ihåg att byta lösenord om dina data har läckt.",
      "title": "Har dina uppgifter läckt?"
    },
    "overview": {
      "text": "Hej {name}! Phishingangrepp är den vanligaste typen av cyberangrepp i världen och utgör en stor säkerhetsrisk för din arbetsplats. Här i portalen kan du lära dig ännu mer om phishing och andra cyberangrepp som kan drabba både dig och verksamheten. Du kan också följa dina framsteg och genomföra säkerhetsutmaningar.",
      "title": "Välkommen till lärandeportalen!"
    },
    "quiz": {
      "text": "Ta ett interaktivt quiz som utmanar din förmåga att skilja mellan legitima e-postmeddelanden och phishing. Quizet är utformat för att testa din kunskap och förståelse för de hot du kan möta i verkligheten.",
      "title": "Ta ett quiz"
    },
    "simulations": {
      "text": "På den här sidan kan du se detaljer om de phishingsimuleringar som du har fått de senaste 90 dagarna. Genom att granska detaljerna får du en bättre förståelse för hur phishingmail är uppbyggda och hur du skyddar dig mot dem.",
      "title": "Har du blivit utsatt för phishing?"
    },
    "videos": {
      "text": "Här på sidan kan du se videor om cyberhot och lära dig hur du skyddar dig själv och din arbetsplats mot dem. Det kommer kontinuerligt nya träningsvideor, så att du alltid har möjlighet att ta till dig ny kunskap.",
      "title": "Gör dig redo att lära dig något nytt"
    }
  },
  "certificate": {
    "certificate_of_completion": "Certifikat för genomförande",
    "certificate_unlocked": "Certifikat aktiverat",
    "share_on_linkedin": "Dela på LinkedIn",
    "show_certificate": "Visa certifikat",
    "text": "Du har uppnått ett certifikat från din senaste kurs – varför inte visa upp det?"
  },
  "courses": {
    "all": "Alla kurser",
    "completed": {
      "badge": "Genomfört",
      "button": "Slutför kursen",
      "text": "Du har genomfört kursen",
      "title": "Bra jobbat!"
    },
    "content": {
      "breach": {
        "text": "Aktivera övervakning av dataintrång på ditt konto",
        "title": "Övervakning av dataläckor"
      },
      "download": {
        "button": "Ladda ner"
      },
      "introduction": {
        "contents": "Innehåll",
        "start": "Starta kursen",
        "text": "Kursbeskrivning och översikt",
        "title": "Introduktion"
      },
      "quiz": {
        "choose_answer": "Välj det rätta svaret nedan:",
        "correct": "Korrekt",
        "correct_answer": "{label}: {answer}",
        "correct_answer_label": "Rätt svar",
        "next_question": "Nästa fråga",
        "oh_no": "Oj!",
        "question_of": "Fråga {current} av {total}",
        "result": {
          "button": "Slutför quiz",
          "text": "Du svarade korrekt på {correct} av {total} frågor.",
          "title": "Bra jobbat!",
          "title_fail": "Nästan!"
        },
        "text": "Testa dina kunskaper med ett quiz",
        "title": "Quiz",
        "view_results": "Gå till resultat",
        "well_done": "Bra jobbat!",
        "your_answer": "{label}: {answer}",
        "your_answer_label": "Ditt svar"
      },
      "video": {
        "text": "Lär dig de viktigaste begreppen genom att titta på den här videon"
      }
    },
    "continue": "Fortsätt",
    "featured": "Utvalda kurser",
    "lessons": "{count} lektioner",
    "progress": {
      "button": "Fortsätt",
      "text": "Du har genomfört {pct}% av den här kursen."
    },
    "skip_video": {
      "button": "Hoppa över",
      "text": "Du har redan sett den här videon. Vill du hoppa över den?"
    },
    "start_over": "Starta om",
    "title": "Kurser"
  },
  "dynamic_keys": {
    "api": {
      "errors": {
        "checksum": "Frågan har löpt ut",
        "network": "Ett fel har uppstått",
        "noResponse": "Det uppstod ett serverfel",
        "streaming": {
          "manifest": "Det uppstod ett fel vid uppspelning av videon",
          "platform": "Din plattform stöder inte videoströmning",
          "unavailable": "Den här videon är inte tillgänglig"
        },
        "unknown": "Ett okänt fel har uppstått"
      },
      "messages": {
        "auth_failed": "Ogiltig e-post",
        "csrf": "Ladda om sidan och försök igen",
        "email_missing": "Ingen e-postadress är kopplad till kontot",
        "file_not_found": "Filen existerar inte",
        "general_exception": "Ett fel har uppstått",
        "invalid_answer": "Ogiltigt svar",
        "invalid_course": "Ogiltig kurs",
        "invalid_domain": "Ogiltig domän",
        "invalid_email": "E-postadressen är ogiltig",
        "invalid_grant": "Leverantören kunde inte nås",
        "invalid_locale": "Översättning existerar inte",
        "invalid_option": "Ogiltigt svarsalternativ",
        "invalid_permissions": "Du har inte tillstånd att använda den här funktionen",
        "invalid_point": "Ogiltigt poäng",
        "invalid_provider": "Ogiltig leverantör",
        "invalid_quiz": "Quizet finns inte",
        "invalid_token": "Din session har löpt ut.",
        "invalid_video": "Den här videon finns inte",
        "missing_code": "Försök igen",
        "two_factor_code_expired": "Engångskoden har löpt ut",
        "two_factor_code_invalid": "Engångskoden är ogiltig",
        "unauthorized": "Du har inte tillåtelse att använda den här funktionen",
        "user_not_found": "Användaren finns inte"
      },
      "validations": {
        "messages": {
          "throttle": "För många inloggningsförsök. Försök igen senare."
        }
      }
    },
    "breaches": {
      "data_classes": {
        "account_balances": "Kontosaldon",
        "address_book_contacts": "Adressbokskontakter",
        "age_groups": "Åldersgrupper",
        "ages": "Åldrar",
        "appointments": "Möten",
        "apps_installed_on_devices": "Appar installerade på enheter",
        "astrological_signs": "Astrologiska tecken",
        "audio_recordings": "Ljudinspelningar",
        "auth_tokens": "API-token",
        "avatars": "Profilbilder",
        "bank_account_numbers": "Bankkontonummer",
        "beauty_ratings": "Skönhetsomdömen",
        "biometric_data": "Biometriska data",
        "bios": "Biografier",
        "browser_user_agent_details": "User agent-information",
        "browsing_histories": "Webbhistorik",
        "buying_preferences": "Köpvanor",
        "car_ownership_statuses": "Bilinnehavsstatus",
        "career_levels": "Karriärnivåer",
        "cellular_network_names": "Mobilnätsnamn",
        "charitable_donations": "Välgörenhetsdonationer",
        "chat_logs": "Chattloggar",
        "credit_card_cvv": "Kreditkorts-CVV-koder",
        "credit_cards": "Kreditkort",
        "credit_status_information": "Information om kreditvärdighet",
        "customer_feedback": "Kundfeedback",
        "customer_interactions": "Kundinteraktioner",
        "dates_of_birth": "Födelsedatum",
        "deceased_date": "Datum för dödsfall",
        "deceased_statuses": "Uppgifter om avlidna",
        "device_information": "Enhetsinformation",
        "device_serial_numbers": "Enhetsserienummer",
        "device_usage_tracking_data": "Data om enhetsanvändning",
        "drinking_habits": "Dryckesvanor",
        "driver_s_licenses": "Körkort",
        "drug_habits": "Drogvanor",
        "eating_habits": "Matvanor",
        "education_levels": "Utbildningsnivåer",
        "email_addresses": "E-postadresser",
        "email_messages": "E-postmeddelanden",
        "employers": "Arbetsgivare",
        "employment_statuses": "Sysselsättningsstatus",
        "encrypted_keys": "Krypterade nycklar",
        "ethnicities": "Etniciteter",
        "family_members_names": "Familjemedlemmars namn",
        "family_plans": "Familjeplaner",
        "family_structure": "Familjestruktur",
        "financial_investments": "Finansiella investeringar",
        "financial_transactions": "Finansiella transaktioner",
        "fitness_levels": "Fitnessnivåer",
        "genders": "Könstillhörigheter",
        "geographic_locations": "Geografiska platser",
        "government_issued_i_ds": "Myndighetsutfärdade ID-handlingar",
        "health_insurance_information": "Information om sjukförsäkring",
        "historical_passwords": "Tidigare lösenord",
        "hiv_statuses": "Hiv-status",
        "home_loan_information": "Information om bolån",
        "home_ownership_statuses": "Bostadsägandestatus",
        "homepage_ur_ls": "Webbadresser",
        "imei_numbers": "IMEI-nummer",
        "imsi_numbers": "IMSI-nummer",
        "income_levels": "Inkomstnivåer",
        "instant_messenger_identities": "Meddelandetjänstidentiteter",
        "ip_addresses": "IP-adresser",
        "job_applications": "Jobbansökningar",
        "job_titles": "Jobbtitlar",
        "licence_plates": "Registreringsnummer",
        "living_costs": "Levnadskostnader",
        "login_histories": "Inloggningshistorik",
        "mac_addresses": "MAC-adresser",
        "marital_statuses": "Civilstånd",
        "mnemonic_phrases": "Minnesfraser",
        "mothers_maiden_names": "Moderns flicknamn",
        "names": "Namn",
        "nationalities": "Nationaliteter",
        "net_worths": "Förmögenheter",
        "nicknames": "Smeknamn",
        "occupations": "Yrken",
        "parenting_plans": "Föräldraplaner",
        "partial_credit_card_data": "Delvisa kreditkortsuppgifter",
        "partial_dates_of_birth": "Delvisa födelsedatum",
        "passport_numbers": "Passnummer",
        "password_hints": "Lösenordstips",
        "password_strengths": "Lösenordsstyrkor",
        "passwords": "Lösenord",
        "payment_histories": "Betalningshistorik",
        "payment_methods": "Betalningsmetoder",
        "personal_descriptions": "Personliga beskrivningar",
        "personal_health_data": "Personliga hälsouppgifter",
        "personal_interests": "Personliga intressen",
        "phone_numbers": "Telefonnummer",
        "photos": "Foton",
        "physical_addresses": "Fysiska adresser",
        "physical_attributes": "Fysiska attribut",
        "pi_ns": "PIN-koder",
        "places_of_birth": "Födelseorter",
        "political_donations": "Politiska donationer",
        "political_views": "Politiska åsikter",
        "private_messages": "Privata meddelanden",
        "professional_skills": "Yrkeskompetenser",
        "profile_photos": "Profilbilder",
        "purchases": "Köp",
        "purchasing_habits": "Inköpsvanor",
        "races": "Rastillhörigheter",
        "recovery_email_addresses": "Återställningsadresser",
        "relationship_statuses": "Relationsstatus",
        "religions": "Religioner",
        "reward_program_balances": "Bonusprogramssaldon",
        "salutations": "Hälsningsfraser",
        "school_grades_class_levels": "Skolbetyg och klassnivåer",
        "security_questions_and_answers": "Säkerhetsfrågor och svar",
        "sexual_fetishes": "Sexuella fetischer",
        "sexual_orientations": "Sexuella läggningar",
        "smoking_habits": "Rökvanor",
        "sms_messages": "SMS-meddelanden",
        "social_connections": "Sociala kontakter",
        "social_media_profiles": "Profiler i sociala medier",
        "social_security_numbers": "Personnummer",
        "spoken_languages": "Talade språk",
        "spouses_names": "Make/makas namn",
        "support_tickets": "Supportärenden",
        "survey_results": "Undersökningsresultat",
        "taxation_records": "Skatteuppgifter",
        "time_zones": "Tidszoner",
        "travel_habits": "Resevanor",
        "user_statuses": "Användarstatus",
        "user_website_urls": "Användares webbadresser",
        "usernames": "Användarnamn",
        "utility_bills": "Förbrukningsräkningar",
        "vehicle_details": "Fordonsuppgifter",
        "website_activity": "Webbplatsaktivitet",
        "work_habits": "Arbetsvanor",
        "years_of_professional_experience": "Yrkeserfarenhet i år"
      }
    },
    "certificates": {
      "compliance": "Cybersäkerhetsutbildning"
    },
    "courses": {
      "toc": {
        "breach-content": "Dataläckor",
        "file-content": "Ladda ner",
        "intro-content": "Introduktion",
        "quiz-content": "Quiz",
        "text-content": "Case",
        "video-content": "Video"
      }
    },
    "locales": {
      "current": "svenska",
      "da_DK": "dansk",
      "de_DE": "deutsch",
      "en_US": "english",
      "es_ES": "Spanska",
      "fi_FI": "suomi",
      "fr_FR": "Franska",
      "nb_NO": "norsk",
      "nl_NL": "nederländska",
      "pl_PL": "polski",
      "pt_PT": "português",
      "sv_SE": "svenska"
    },
    "onboarding": {
      "course": {
        "content": [
          {
            "attributes": {
              "description": "Välkommen till din personliga utbildningsplattform! Vi är glada att ha dig här och ser fram emot att hjälpa dig att nå dina kunskapsmål.",
              "title": "Välkommen till Moxso"
            },
            "layout": "intro-content"
          },
          {
            "attributes": {
              "title": "Så fungerar Moxso",
              "video_id": "af422bc9-145b-4cf4-a9d4-de16a9dcbc61"
            },
            "layout": "video-content"
          },
          {
            "layout": "breach-content"
          }
        ],
        "id": "4a36d036-d378-449a-aa85-e62afd6e31f4",
        "image": "https://edge-cdn.moxso.com/course/4SuGbThgaOWPd69hzrD8oYqkwEkTvNzDMPEoHhrK.jpg",
        "title": "Välkommen till 🙌",
        "video": "https://edge-cdn.moxso.com/course/Tzk7FcRcvAHMlm35ACZNK4zIsRFvQGQimfpcKeCW.mp4"
      },
      "quiz_questions": {
        "data_privacy": {
          "category": "Medvetenhet om dataskydd",
          "options": {
            "high": "Bekant",
            "low": "Inte bekant",
            "medium": "Något bekant"
          },
          "question": "Hur bekant är du med de grundläggande principerna för dataskydd (t.ex. GDPR)?"
        },
        "device_security": {
          "category": "Enhetssäkerhetsrutiner",
          "options": {
            "high": "Ja, alltid",
            "low": "Nej, aldrig",
            "medium": "Ibland"
          },
          "question": "Uppdaterar du regelbundet dina enheter och använder säkerhetsverktyg som VPN?"
        },
        "digital_threats": {
          "category": "Medvetenhet om digitala hot",
          "options": {
            "high": "Bekant",
            "low": "Inte bekant",
            "medium": "Något bekant"
          },
          "question": "Hur bekant är du med digitala hot som malware, phishing och ransomware?"
        },
        "hybrid_work": {
          "category": "Säkerhet vid distansarbete",
          "options": {
            "high": "Mycket säker",
            "low": "Inte säker",
            "medium": "Något säker"
          },
          "question": "Hur säker är du på att bibehålla säkerhet när du arbetar på distans (t.ex. via offentligt Wi-Fi)?"
        },
        "incidents_breaches": {
          "category": "Incidentrapportering",
          "options": {
            "high": "Ja",
            "low": "Nej",
            "medium": "Jag har en allmän uppfattning"
          },
          "question": "Känner du till den korrekta proceduren för att rapportera en säkerhetsincident eller intrång?"
        },
        "passwords_accounts": {
          "category": "Hantering av lösenord",
          "options": {
            "high": "Jag använder en lösenordshanterare",
            "low": "Jag återanvänder lösenord",
            "medium": "Jag skapar unika, starka lösenord"
          },
          "question": "Hur hanterar du lösenord för dina arbetsrelaterade konton?"
        },
        "phishing": {
          "category": "Phishingidentifiering",
          "options": {
            "high": "Mycket säker",
            "low": "Inte säker",
            "medium": "Något säker"
          },
          "question": "Hur säker är du på att identifiera phishingförsök i e-post eller meddelanden?"
        },
        "physical_security": {
          "category": "Fysisk säkerhetsrutiner",
          "options": {
            "high": "Alltid",
            "low": "Sällan",
            "medium": "Ibland"
          },
          "question": "Hur ofta säkerställer du ditt arbetsområde (t.ex. genom att låsa din dator, förvara känsliga dokument)?"
        },
        "secure_browsing": {
          "category": "Säkra surfvanor",
          "options": {
            "high": "Ja, alltid",
            "low": "Nej, aldrig",
            "medium": "Ibland"
          },
          "question": "Undviker du att använda offentlig Wi-Fi eller klicka på misstänkta länkar när du surfar?"
        }
      },
      "steps": {
        "finished": "Färdig",
        "introduction": "Introduktion",
        "quiz": "Quiz"
      }
    },
    "partners": {
      "itf": "IT Forum"
    },
    "quiz": {
      "error": {
        "checksum": "Ogiltigt svar",
        "option": "Ogiltigt svar"
      },
      "intro": {
        "button": "Starta quizet",
        "text": "Vi går igenom 5 e-postmeddelanden i din Moxso-inkorg. Några av dem kan vara från bedragare som försöker få tillgång till känslig information – du måste avgöra om e-postmeddelandet är phishing eller inte. Är du redo?",
        "title": "Redo att rapportera?"
      },
      "multiple-choice": {
        "heading": "Hitta felet i e-posten",
        "text": "Välj det korrekta felet i e-postmeddelandet nedan"
      },
      "options": {
        "email": "E-postmeddelandet",
        "false": "Detta är INTE phishing",
        "help": {
          "email": "Avsändaren är INTE pålitlig",
          "false": "E-postmeddelandet ska INTE rapporteras",
          "link": "Länken leder INTE till en pålitlig destination",
          "not-phishing": "Detta är INTE phishing",
          "true": "E-postmeddelandet bör rapporteras"
        },
        "link": "Länken",
        "not-phishing": "Detta är INTE phishing",
        "true": "Detta är phishing"
      },
      "title": "Quiz",
      "true-false": {
        "heading": "Är detta ett phishingmail?",
        "text": "Ta reda på om detta är ett phishingmail eller inte"
      }
    },
    "training": {
      "training_restritions": {
        "course": {
          "description": "Den här kursen kan inte öppnas. Valfria kurser är låsta, men obligatorisk utbildning är alltid tillgänglig.",
          "title": "Kursgräns nådd"
        },
        "quiz": {
          "description": "Du har nått din träningsgräns. Valfria quiz är tillfälligt låsta.",
          "title": "Quizgräns nådd"
        },
        "video": {
          "description": "Du har nått din träningsgräns. Valfria videor är låsta, men obligatorisk utbildning är alltid tillgänglig.",
          "title": "Videogräns nådd"
        }
      }
    },
    "training_restrictions": {
      "course": {
        "description": "Den här kursen kan inte öppnas. Valfria kurser är låsta, men obligatorisk utbildning är alltid tillgänglig.",
        "title": "Kursgräns nådd"
      },
      "quiz": {
        "description": "Du har nått din träningsgräns. Valfria quiz är tillfälligt låsta.",
        "title": "Quizgräns nådd"
      },
      "reset": "Återställs på måndag",
      "video": {
        "description": "Du har nått din träningsgräns. Valfria videor är låsta, men obligatorisk utbildning är alltid tillgänglig.",
        "limit_reached": "Gräns nådd",
        "title": "Videogräns nådd"
      }
    },
    "videos": {
      "category": {
        "advanced": {
          "text": "Avancerad är en serie för dem som är särskilt intresserade av IT-säkerhet och av att förstå hur de bakomliggande mekanismerna inom hacking och IT-säkerhet fungerar. Om du bara vill ha en grundläggande förståelse för IT-säkerhet, är det inte nödvändigt för dig att se videorna i denna serie. Om du vill veta mer om hacking och cyberangrepp, samt hur du bäst kan säkra din egen IT-säkerhet, så hittar du svaret här.",
          "title": "Avancerad",
          "tooltip": "Bli expert på hacking på rekordtid"
        },
        "ai": {
          "text": "AI-serien dyker ner i den komplexa roll som artificiell intelligens spelar inom cybersäkerhet. AI tjänar ett dubbelt syfte: Det är ett avgörande verktyg för it-säkerhetspersonal att identifiera och hantera hot, samtidigt som det är ett effektivt vapen för hackare. Denna videoserie har som syfte att öka din medvetenhet om AI-genererade phishing-attacker och vägleda dig i att använda AI på ett säkert sätt för att minimera misstag och minska risken för hacking. För även om AI är ett viktigt verktyg både i cyberförsvar och -angrepp, är ditt beteende fortfarande den avgörande faktorn för din säkerhet.",
          "title": "AI och cybersäkerhet",
          "tooltip": "Utforska AI:s komplexa roll inom cybersäkerhet"
        },
        "compliance": {
          "text": "Den här kategorin innehåller videor om viktiga lagar, säkerhetsstandarder och certifieringar som kan bidra till att skydda din arbetsplats mot digitala hot. Videorna ger dig bland annat insikt i NIS2-direktivet och DORA-förordningen, som säkerställer robusta cybersäkerhetsåtgärder och efterlevnad av internationella standarder. Videorna ger insikt i reglernas betydelse, hur man uppnår compliance, och vilka konkreta krav de ställer på företags säkerhet och riskhantering. Du får också förståelse för vad reglerna betyder för dig, och varför de är värda att lägga tid på.",
          "title": "Certifieringar och efterlevnad",
          "tooltip": "Få insikt i betydelsen av certifieringar och compliance"
        },
        "gdpr": {
          "text": "GDPR är en serie som dyker ner i de regler, krav och principer som har fastställts i GDPR. GDPR infördes 2018, och alla företag måste nu följa GDPR för att kunna säkerställa integriteten och skyddet av de personuppgifter som de behandlar. Serien tar upp de mest relevanta områdena inom GDPR som du behöver känna till för att kunna hantera personuppgifter korrekt i din vardag. Denna serie innehåller både videor som riktar sig till alla och videor som riktar sig till anställda i den privata sektorn.",
          "title": "GDPR",
          "tooltip": "Lär dig de viktigaste kraven och reglerna i GDPR, och hur du kan följa dem i din vardag"
        },
        "hacking": {
          "text": "Livet som hacker är en serie, där vi fokuserar på de IT-kriminella, nämligen hackerna. Vi tittar närmare på några av de metoder som hackare använder för att förbli anonyma på nätet, och hur de tjänar sina pengar. I videorna kommer du dessutom att lära dig vilka typer av hackare som finns, och varför hackare är så svåra att fånga.",
          "title": "Livet som hacker",
          "tooltip": "Kom bakom fasaden på världens IT-brottslighet, nämligen hackerna"
        },
        "money_laundering": {
          "text": "Penningtvätt är en serie som går på djupet med de olika metoder som kriminella använder för att tvätta pengar. Videorna kommer att förklara de olika metoder som kriminella använder för att tvätta pengar och hur man upptäcker och förhindrar penningtvätt.",
          "title": "Penningtvätt",
          "tooltip": "Lär dig de olika metoder som kriminella använder för att tvätta pengar och hur man upptäcker och förhindrar penningtvätt"
        },
        "phishing": {
          "text": "Phishing är en serie som går på djupet med det mest utbredda cyberangreppet globalt. Phishing-angrepp kan både stå ensamma och användas som ett sätt att inleda andra, mer avancerade, cyberangrepp. Phishing-angrepp är dessutom det cyberangrepp där du som anställd ensam bär ansvaret för att inte bli hackad, t.ex. genom att undvika att klicka på en länk i ett e-postmeddelande. Phishing är ett väsentligt fokusområde inom IT-säkerhet, och videorna i denna serie ger dig förståelsen för vad phishing är, hur det utförs, och hur du undviker att bli offer för ett phishing-angrepp.",
          "title": "Phishing",
          "tooltip": "Få ingående kunskap om det mest utbredda cyberangreppet globalt"
        },
        "physical_security": {
          "text": "Fysisk säkerhet är en serie som belyser vikten av god säkerhet på arbetsplatsen och i hemmet. Cybersäkerhet handlar om mer än säkerheten på dina enheter, det handlar också om säkerheten runt enheterna. Många är bekanta med distansarbete, och vi förbereder dig för att göra detta så säkert som möjligt. I denna serie får du dessutom insikt i allt från besökshantering till cybersäkerhet på mobila enheter och vilka risker som finns med att använda offentliga nätverk.",
          "title": "Fysisk säkerhet",
          "tooltip": "Få en inblick i varför fysisk säkerhet är ett viktigt element i stark cybersäkerhet"
        },
        "tips_and_tricks": {
          "text": "Tips och tricks är en serie som hjälper dig att öka din säkerhet på nätet. Du kommer att få helt konkreta, praktiska råd om hur du kan öka din personliga säkerhet på nätet och därmed också öka säkerheten på din arbetsplats. Videorna förklarar ytterligare varför de säkerhetsråd som du kanske tidigare har fått av andra än oss här i Moxso är så viktiga att komma ihåg.",
          "title": "Tips och tricks",
          "tooltip": "Lär dig hur du kan öka din säkerhet på nätet"
        },
        "types_of_hacking": {
          "text": "Typer av hacking är en serie som ger dig insikt i de olika metoder som hackare har tillgängliga när de försöker lura dig. Varje avsnitt ger dig en grundläggande förståelse för en specifik hackingmetod. Detta inkluderar kännetecknen för hackingmetoden, vad hackarna kan få ut av just den metoden, konsekvenserna det kan få för dig om du blir hackad m.m. Genom att se videorna i denna serie lär du dig hur hackarna arbetar, och du kommer att bli bättre rustad mot hackerattacker i framtiden.",
          "title": "Typer av hacking",
          "tooltip": "Få en insyn i de olika metoder som hackare använder"
        },
        "uploads": {
          "text": "Den här kategorin innehåller anpassade videor som har laddats upp av din organisation.",
          "title": "Uppladdningar",
          "tooltip": "Titta på videor uppladdade av din organisation för dina specifika säkerhetsbehov"
        }
      }
    }
  },
  "error_page": {
    "error_has_been_reported": "Felet har rapporterats till vårt team med id: {errorId}. Om du behöver omedelbar hjälp är du välkommen att kontakta vårt supportteam på support{'@'}moxso.com.",
    "go_back": "Tillbaka till startsidan",
    "text": "Ett okänt fel inträffade och vi kunde inte slutföra din begäran. Vi beklagar besväret. Försök igen senare.",
    "title": "Något gick fel"
  },
  "forms": {
    "fields": {
      "code": "Engångskod",
      "email": "E-postadress"
    },
    "placeholders": {
      "email": "namn{'@'}företag.se"
    }
  },
  "loading": "Laddar",
  "locale": {
    "current": "Svenska",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "finnish": "Suomi",
    "french": "Français",
    "german": "Deutsch",
    "norwegian": "Norsk",
    "polish": "Polski",
    "portugese": "Português",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "login": {
    "buttons": {
      "login": "Logga in",
      "next": "Nästa",
      "send_one_time_code": "Skicka engångskod",
      "try_again": "Skicka koden igen"
    },
    "choose_provider": "Välj leverantör",
    "loading": "Laddar",
    "sso": {
      "validating": "Validerar SSO"
    },
    "title": "Logga in",
    "two_factor": {
      "text": "Vi har skickat en engångskod till din e-post.",
      "title": "Kontrollera din e-post"
    }
  },
  "mandatory": {
    "completed": {
      "text": "Du har genomfört allt det innehåll som din administratör har valt ut till dig.",
      "title": "Bra jobbat!"
    },
    "deadline": "Deadline för genomförande: {date}",
    "next_training": "Nästa tilldelade träning",
    "policy_fallback_title": "Policy",
    "quiz_questions": "{count} fråga | {count} frågor",
    "retake": "Gör om",
    "start_quiz": "Starta quiz",
    "text": "Din tilldelade träning",
    "title": "Tilldelad träning",
    "view_policy": "Visa policy"
  },
  "navigation": {
    "breaches": "Dataläckor",
    "courses": "Kurser",
    "exit": "Avsluta",
    "exit_onboarding": "Hoppa över",
    "login": "Logga in",
    "logout": "Logga ut",
    "onboarding": "Introduktion",
    "onboarding_finished": "Onboarding klar",
    "onboarding_intro": "Onboarding introduktion",
    "onboarding_quiz": "Onboarding quiz",
    "overview": "Översikt",
    "simulation_click": "Phishingsimulering",
    "simulations": "Simulationer",
    "videos": "Videor"
  },
  "onboarding": {
    "finished": {
      "button": "Börja lära",
      "subtitle": "Du har slutfört din onboarding! Bra jobbat, du är nu redo att börja använda Moxso. Vi är glada att ha dig ombord och ser fram emot att hjälpa dig nå dina mål!",
      "title": "Det var det!"
    },
    "intro": {
      "form": {
        "button": "Spara och fortsätt",
        "help": "Välj det språk du vill använda för din lärandeupplevelse.",
        "label": "Välj ditt språk",
        "placeholder": "Välj språk"
      },
      "header": {
        "description": "Välkommen till din lärandeplattform! Vi är glada att ha dig här och redo att hjälpa dig nå dina mål. Låt oss sätta upp din profil och anpassa din upplevelse.",
        "title": "Välkommen till Moxso"
      }
    },
    "quiz": {
      "header": {
        "description": "Genomför detta korta quiz för att hjälpa oss förstå din nuvarande nivå, så att vi kan anpassa utbildningen efter dina behov.",
        "title": "Hur bra känner du till cybersäkerhet?"
      }
    }
  },
  "overview": {
    "start_quiz": "Ta ett quiz",
    "welcome": "Välkommen tillbaka"
  },
  "partner_text": "Moxsos plattform presenteras i samarbete med {partner}.",
  "policies": {
    "cancel": {
      "text": "Denna policy har avbrutits av din administratör.",
      "title": "Avbruten policy"
    },
    "continue": "Fortsätt",
    "expired": {
      "text": "Denna policy har gått ut och är inte längre tillgänglig.",
      "title": "Utgången policy"
    },
    "focus": "Fokus",
    "history": {
      "count": "{count} signerade",
      "show_less": "Visa mindre",
      "signed": "Signerad: {date}",
      "subtitle": "Granska policyer som du redan har signerat.",
      "title": "Signerade policyer",
      "view_more": "Visa mer"
    },
    "next": "Nästa",
    "overview": "Innehållsöversikt",
    "policy": "Policy",
    "quiz": {
      "confirmation_card_locked": "Du måste slutföra quizet för att fortsätta",
      "subtitle": "Visa att du förstår policyn genom att göra det här quizet.",
      "subtitle_completed": "Du har slutfört quizet, bekräfta att du har läst policyn för att avsluta.",
      "title": "Quiz",
      "title_completed": "Quiz slutfört"
    },
    "reader": "Läsvisning",
    "signature": {
      "button": "Godkänn",
      "checkbox_label": "Jag har läst policyn",
      "company": "Företag",
      "completed": {
        "button": "Avsluta",
        "policy_completed": "Policy accepterad",
        "subtitle": "Bra jobbat! Du har accepterat policyn.",
        "title": "Policy accepterad"
      },
      "ip_adress": "IP-adress",
      "subtitle": "Genom att bekräfta intygar du att du har läst och förstått policyn.",
      "title": "Bekräfta läsning av policy",
      "user_agent": "Användaragent"
    },
    "this_policy_doesnt_exist_in_this_language": "Denna policy är inte tillgänglig på svenska. Visar {locale}-versionen."
  },
  "quiz": {
    "analyze": {
      "text": "Analysera e-postmeddelandet och få stöd",
      "title": "Osäker?"
    },
    "feedback": {
      "no": "Nej",
      "text": "Var den här artikeln till hjälp?",
      "thanks": "Tack för din feedback!",
      "yes": "Ja"
    },
    "help": {
      "button": "Nästa fråga",
      "text": "Vi har analyserat e-postmeddelandet och identifierat följande",
      "title": "E-postanalys"
    },
    "intro": {
      "button": "Starta quizet",
      "text": "Vi går igenom 5 e-postmeddelanden i din Moxso-inkorg. Några av dem kan vara från bedragare som försöker få tillgång till känslig data – du måste avgöra om e-postmeddelandet är phishing eller inte. Är du redo?",
      "title": "Redo att rapportera?"
    },
    "preview": "Förhandsgranska",
    "question": "Fråga {current} av {total}",
    "result": {
      "go_back": "Gå till din översikt",
      "mails": "Fångat e-postmeddelande | Fångade e-postmeddelanden",
      "points": "Intjänade poäng",
      "text": {
        "bad": "Du kategoriserade tyvärr bara {count} e-postmeddelande korrekt. Men kom ihåg: Övning ger färdighet! | Du kategoriserade tyvärr bara {count} e-postmeddelanden korrekt. Men kom ihåg: Övning ger färdighet!",
        "good": "Du kategoriserade {count} e-postmeddelanden korrekt och genomförde quizet. Fortsätt det goda arbetet!"
      },
      "title": {
        "bad": "Bättre lycka nästa gång!",
        "good": "Bra jobbat!"
      }
    },
    "title": "Quiz"
  },
  "resilience_score": {
    "long_text": "Din motståndskraftspoäng mäter din förmåga att motstå cyberangrepp. Poängen beräknas utifrån ditt beteende i quiz, videor och simulationer. Ju högre din motståndskraft är, desto bättre är du på att skydda dig själv och ditt företag mot cyberangrepp.",
    "quizzing": {
      "text": "Öka din motståndskraft genom att göra ett quiz efter varje video.",
      "title": "Quiz"
    },
    "show_breakdown": "Visa detaljer",
    "simulations": {
      "text": "Ett säkert beteende i phishing-simuleringar förbättrar din motståndskraft. Klicka aldrig, och kom ihåg att rapportera!",
      "title": "Simulationer"
    },
    "skills": {
      "text": "Dina färdigheter bygger på hur du besvarar quiz. Korrekta svar ökar motståndskraften.",
      "title": "Färdigheter"
    },
    "text": "Din poäng mäter din förmåga att motstå cyberattacker.",
    "title": "Din motståndskraft",
    "videos": {
      "text": "Videor är en viktig del av din utbildning. Öka din motståndskraft genom att se videor.",
      "title": "Videor"
    }
  },
  "search": {
    "empty": "Sök bland videor och kurser...",
    "no_results": "Inga resultat hittades",
    "placeholder": "Sök...",
    "popular": "Populära sökningar",
    "popular_terms": ["Ransomware", "Social ingenjörskonst"]
  },
  "simulation": {
    "alert": {
      "text": "Du har klickat på en länk i en simulerad phishingattack, men var lugn, det är bara en övning och ingen skada har skett.",
      "title": "Detta är en phishingövning"
    },
    "baseline": {
      "text": "Vi testar just nu dina kollegor. Var snäll och dela inte det här meddelandet med någon.",
      "title": "Kan du hålla på en hemlighet?"
    },
    "branding": {
      "text": "Om du har några frågor eller behöver hjälp, tveka inte att kontakta oss.",
      "title": "Denna övning levererades av Moxso"
    },
    "delivered_by": {
      "text": "Denna övning levererades av Moxso på uppdrag av {companyName}. Om du har frågor är du välkommen att kontakta {contactEmail}.",
      "title": "Om denna övning"
    },
    "preview": "Förhandsvisning",
    "resilience_score": {
      "text": "Din motståndskraftspoäng mäter din förmåga att motstå cyberattacker.",
      "title": "Din motståndskraftspoäng"
    },
    "submission": {
      "text": "Du klickade på en länk och hamnade på en falsk men övertygande webbsida. Vid en riktig phishingattack kunde dina inloggningsuppgifter ha stulits. Lyckligtvis var detta bara ett test.",
      "title": "Vad hände nyss?"
    },
    "training": {
      "button": "Starta din träning"
    }
  },
  "simulations": {
    "count": "Du har inte fått några simuleringar de senaste 90 dagarna. | Du har fått en simulering inom de senaste 90 dagarna. | Du har fått {count} simuleringar inom de senaste 90 dagarna.",
    "empty": {
      "text": "Du har inte fått några simuleringar de senaste 90 dagarna.",
      "title": "Inga simuleringar"
    },
    "joined": "Du registrerades för träningsprogrammet",
    "title": "Simulationer",
    "tooltip": {
      "click": "Du har klickat på länken i den här simuleringen.",
      "report": "Du har rapporterat den här simuleringen.",
      "submit": "Du har loggat in i den här simuleringen."
    }
  },
  "sso": {
    "login_with": "Fortsätt med {provider}",
    "or": "eller använd SSO",
    "redirect": "Omdirigerar"
  },
  "statistics": {
    "leaderboard": "Topplista",
    "missing_data": {
      "text": "Du har inte samlat tillräckligt med poäng för att se din placering på topplistan ännu.",
      "title": "Samla poäng för att se din placering"
    },
    "points_earned": "{count} intjänade poäng",
    "resilience_score": "Motståndskraft"
  },
  "videos": {
    "error": "Streaming är för närvarande otillgänglig",
    "latest": "Senaste videor",
    "more": "Visa mer",
    "not_available_in_your_locale": "Denna video är inte tillgänglig på svenska. Vi har automatiskt bytt till engelska.",
    "play": "Starta video",
    "quiz": {
      "resume": "Fortsätt quiz",
      "title": "Quiz"
    },
    "related": "Relaterade videor",
    "related_videos": "Föreslagna videor",
    "title": "Videor",
    "watch_again": "Titta igen"
  }
}
